import useModuleTranslation from "../infra-no-ui/translation/useModuleTranslation";
import React from "react";

/**
 * Dynamically load translation files pertaining to the menu module.
 * @return {*}
 */
export default function useTranslationMenu() {

  // Imports must be memoized so that they don't change on every render
  const imports = React.useMemo(() => ({
    'en': import('./locales/en/menu.json'),
    'fr': import('./locales/fr/menu.json')
  }), []);

  return useModuleTranslation('menu', imports);
}
